import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { IReqWebhook, Webhook, WebhookHistory, WebhookSaveDto } from "../../entities/webhook";
import { ApiQueryParams, ResponseObjectList } from "../../entities/global";

export const getWebhooks = createAsyncThunk(
  "webhook/get-webhook-list",
  async (params?: ApiQueryParams): Promise<IReqWebhook> => {
    const query = encodeGetParams({ ...params });
    const res = await agent.get(`${apiUrlV1}/organization/webhook/${query}`);
    if (res.ok) {
      const data = (await res.json()) as IReqWebhook;
      return data;
    }
    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
);

export const getWebhook = createAsyncThunk(
  "webhook/get-webhook",
  async (id: string | number): Promise<Webhook | undefined> => {
    const res = await agent.get(`${apiUrlV1}/organization/webhook/${id}`);
    if (res.ok) {
      const data = await res.json();
      return data;
    }
    return undefined;
  }
);

export const createWebhook = createAsyncThunk(
  "webhook/create",
  async (dto: WebhookSaveDto): Promise<Webhook | undefined> => {
    const res = await agent.post(`${apiUrlV1}/organization/webhook`, {
      body: JSON.stringify(dto),
    });
    if (res.ok) return res.json();
    return undefined;
  }
);

export const updateWebhook = createAsyncThunk(
  "webhook/update",
  async ({ id, dto }: { id: string; dto: Partial<WebhookSaveDto> }): Promise<Webhook | undefined> => {
    const res = await agent.patch(`${apiUrlV1}/organization/webhook/${id}`, {
      body: JSON.stringify(dto),
    });
    if (res.ok) return res.json();
    return undefined;
  }
);

export const deleteWebhook = createAsyncThunk(
  "webhook/delete",
  async (id: string): Promise<string | undefined> => {
    const res = await agent.delete(`${apiUrlV1}/organization/webhook/${id}`);
    if (res.ok) return id;
    return undefined;
  }
);

export const getWebhookHistory = createAsyncThunk(
  `webhook/get-webhook-history`,
  async (params: {
    id: number | string;
    meta?: ApiQueryParams;
  }): Promise<ResponseObjectList<WebhookHistory[]>> => {
    try {
      const query = encodeGetParams({ ...params?.meta });
      const res = await agent.get(
        `${apiUrlV1}/organization/webhook/history/${params.id}${query}`
      );
      if (res.ok) {
        const req = (await res.json()) as ResponseObjectList<WebhookHistory[]>;
        return req;
      }
      if (!res.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: [],
    };
  }
);
